import { NPC_CONFIG } from '../content/generated/entities.gen';
import { QUEST_DATABASE } from '../content/generated/quests.gen';

export const UNKNOWN_QUEST_END_NPC_NAME = 'Unknown';

export interface QuestEndNpcDisplay {
  npcId: string | null;
  name: string;
}

/** Resolve an authored NPC id through the generated NPC roster. */
export function resolveQuestEndNpcDisplay(endNpcId?: string | null): QuestEndNpcDisplay {
  if (!endNpcId) {
    return { npcId: null, name: UNKNOWN_QUEST_END_NPC_NAME };
  }
  return {
    npcId: endNpcId,
    name: NPC_CONFIG[endNpcId]?.name ?? UNKNOWN_QUEST_END_NPC_NAME,
  };
}

/** Resolve a quest's authored hand-in NPC through generated quest + NPC data. */
export function questEndNpcDisplay(questId: string): QuestEndNpcDisplay {
  return resolveQuestEndNpcDisplay(QUEST_DATABASE[questId]?.endNpc);
}
